import { css, styled } from '@topwrite/common';
import { Fragment } from 'react';
import { ReactComponent as LoadingIcon } from '../../images/three-dots.svg';
import Content, { ContentType } from './content';
import FileItem from './file-item';
import Tool, { ToolMessage } from './tool';
import Reasoning from './reasoning';

export interface Message {
    id?: string;
    input?: {
        query: string
        files?: { path: string; name: string }[]
        context?: {
            filename: string;
            range?: FileRange | null;
        }
    };
    output?: {
        content: string | ContentType[];
        reasoning?: string;
        tools?: ToolMessage[]
        error?: string
    }[];
    loading?: boolean;
}

interface Props {
    message: Message;
}

export default function MessageItem({ message }: Props) {
    const { input, output, loading } = message;

    return <>
        {input && <Container $reverse={true}>
            <Body>
                <Content value={input.query} />
                {(input.files || []).map(({ name }, index) => {
                    return <FileWrap key={index}><FileItem name={name} /></FileWrap>;
                })}
            </Body>
        </Container>}
        {output && <Container>
            <Body>
                <Chunks>
                    {output.length > 0 && output.map((chunk, index) => {
                        return <Fragment key={index}>
                            {chunk.reasoning?.trim() &&
                                <Reasoning reasoning={chunk.reasoning} loading={!chunk.content && (chunk.tools || []).length === 0} />}
                            {chunk.content && <Content value={chunk.content} />}
                            {(chunk.tools || []).map((tool, index) => {
                                return <Tool key={index} tool={tool} loading={loading} />;
                            })}
                            {chunk.error && <Content value={`[${chunk.error}]`} />}
                        </Fragment>;
                    })}
                </Chunks>
                {loading && <LoadingIcon />}
            </Body>
        </Container>}
    </>;
}


const Body = styled.div`
    padding: .875rem;
    background-color: var(--ttw-message-background);
    border-radius: var(--bs-border-radius-lg);
    max-width: 100%;
    position: relative;
`;

const Container = styled.div<{ $reverse?: boolean }>`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }

    ${props => props.$reverse && css`
        flex-direction: row-reverse;

        ${Body} {
            background: rgba(var(--bs-primary-rgb), 0.1);
        }
    `};
`;

const FileWrap = styled.div`
    width: 100%;
    margin-bottom: .5rem;
    margin-top: .5rem;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

const Chunks = styled.div`

`;
